<template>
	<section>
        <div class="block">
            <el-timeline>
                <el-timeline-item :timestamp="item.time" placement="top" v-for="item in records" :key="item.id">
                <el-card>
                    <h3>{{item.version}}</h3>
                    <p  v-for="itemArr in item.arr" :key="itemArr">{{itemArr}}</p>
                </el-card>
                </el-timeline-item>
            </el-timeline>
        </div>
	</section>
</template>

<script>
	import {getVersionHistoryList}	from '../../api/api';

	export default {
		data() {
			return {
				records: [],
			}
		},
		methods: {
			//获取数据列表
			getOptLog() {
				getVersionHistoryList().then((res) => {
					if(res.data.result=="true"){
                        this.records = res.data.datas;
                        for (let index = 0; index < this.records.length; index++) {
                            const element = this.records[index];
                            var content=element.content;
                            var arr=content.split("</br>");
                            element.arr=arr;
                        }
                    }
				});
			}
		},
		mounted() {
			this.getOptLog();
		}
	}

</script>

<style scoped>
	#smallMapCon{
		float: left;
		width: 45%;
		height: 350px;
	}
	#smallMap{
		width: 100%;
		height: 300px;
	}
	.dialog-footer{
		text-align: right;
	}
	.isShow{
		display: block;
	}
	.notShow{
		display: none;
	}
</style>


// WEBPACK FOOTER //
// VersionHistory.vue?5dc172c4